<div class="summary">
    <div class="summary__row" *ngFor="let item of items">
        <div class="summary__col">{{item.title}}</div>

        <div *ngIf="item.type === 'number'" class="summary__col">{{item.amount | number}}</div>
        <div *ngIf="item.type === 'currency'" class="summary__col">{{item.amount | currency}}</div>
    </div>
</div>
